import clientConfig from '../client/config';

export function makePhotoUrl(photo: string, template?: string): string {
  return `${clientConfig.imageServiceUrl}${photo}${
    template ? `?template=${template}` : ''
  }`;
}
